import { Fragment, memo, ReactElement } from 'react';
import AccordionFilterNotifications from './filter-notifications';
import {
  FilterResearchNotificationsSide,
  FilterResearchNotificationsSideFlags,
} from 'civil-status/view-models/notifications-list-side';
import { ItemVM } from 'shell/view-models/item';

interface FilterNotificationsProps {
  openNotifications?: boolean;
  setOpenNotifications: (value: boolean) => void;
  handleSubmitResearchNotifications: (values: FilterResearchNotificationsSide) => void;
  idCat?: string;
  initialValues?: FilterResearchNotificationsSide;
  visibleFilters?: FilterResearchNotificationsSideFlags;
  filterKindNotification?: (items: ItemVM[]) => ItemVM[];
}

const FilterNotificationsComponent = ({
  openNotifications,
  setOpenNotifications,
  handleSubmitResearchNotifications,
  idCat,
  initialValues,
  visibleFilters,
  filterKindNotification,
}: FilterNotificationsProps): ReactElement => {
  return (
    <Fragment>
      <AccordionFilterNotifications
        open={openNotifications}
        setOpen={setOpenNotifications}
        handleSubmitResearchNotifications={handleSubmitResearchNotifications}
        idCat={idCat}
        initialValues={initialValues}
        visibleFilters={visibleFilters}
        filterKindNotification={filterKindNotification}
      />
    </Fragment>
  );
};

FilterNotificationsComponent.displayName = 'Research notifications Side - Filters component';

const FilterNotifications = memo(FilterNotificationsComponent);

export default FilterNotifications;
